import { render, staticRenderFns } from "./TwinCityIntro.vue?vue&type=template&id=5e5e6dd0&scoped=true&"
import script from "./TwinCityIntro.vue?vue&type=script&lang=js&"
export * from "./TwinCityIntro.vue?vue&type=script&lang=js&"
import style0 from "./TwinCityIntro.vue?vue&type=style&index=0&id=5e5e6dd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5e6dd0",
  null
  
)

export default component.exports